import NuxLayout from "components/UI/molecules/NuxLayout";
import { COLORS, COMPONENT_TYPES } from "helpers/utils/constants";
import { NotLoggedInTabs } from "pages/organization";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ENDPOINTS } from "store/api/endpoints";
import useAssociation from "store/association";
import useAuth from "store/auth/service-hook";
import useRedirect from "helpers/hooks/useRedirect";
import JobsListing from "pages/jobNetwork/listings/JobsListing";
import useListingHeader from "helpers/hooks/useListingHeader";
import GridSwitch from "components/UI/atoms/GridSwitch";
import { Stack } from "@mui/material";
import Input from "components/Input";
import { Search } from "@mui/icons-material";
import useJobNetwork from "store/job-network";
import { jobNetwork } from "assets/svg/pink/exports";
import EmptyText from "components/UI/atoms/EmptyText";

export const getJobNUX = (onClick) => ({
  0: {
    title: "You have no Jobs to manage. Let’s create your first Job!",
    nuxCardData: {
      title: "Create Your First Job",
      icon: jobNetwork,
      bgColor: COLORS.PINK,
      onClick,
    },
  },
});

const AssociateJobsListing = ({
  manage,
  slug,
  smallView,
  parent,
  emptyView,
  emptyMessageNotLoggedIn,
  disableManage,
}) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pages, setPages] = useState(1);
  const [page, setPage] = useState(1);
  const [text, setText] = useState("");
  const {
    state: { isLoggedIn },
  } = useAuth();
  const { fetchAssociation } = useAssociation();
  const { applyJob, deleteJob } = useJobNetwork();
  const { t } = useTranslation("common");
  const { navigateCreateJob } = useRedirect();
  const { search, setSearch, gridType, setGridType } = useListingHeader();

  const handleFetchAssociation = async () => {
    try {
      setLoading(true);
      const res = await fetchAssociation(parent, slug, ENDPOINTS.JOB_NETWORK, {
        page,
        search,
      });
      if (!res || !Array.isArray(res)) {
        throw new Error("Invalid response");
      }
      const [list, totalPages] = res;
      setJobs(list || []);
      setPages(totalPages || 1);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchAssociation();
  }, [page, search]);

  const handleApplyJob = async (uuid) => {
    const res = await applyJob(uuid);
    if (res?.data?.success)
      setJobs((prev) =>
        prev.map((d) => ({
          ...d,
          application_applied:
            d?.uuid === uuid ? "yes" : d?.application_applied,
          application_status:
            d?.uuid === uuid ? "pending" : d?.application_status,
        }))
      );
  };

  const handleDeleteJob = async (uuid) => {
    await deleteJob(uuid);
    setJobs((prev) => prev.filter((d) => d?.uuid !== uuid));
  };

  return (
    <>
      {!isLoggedIn ? (
        <NotLoggedInTabs
          title={
            emptyMessageNotLoggedIn ||
            `Login to view jobs in this ${parent.split("-").join(" ")}`
          }
        />
      ) : (
        <>
          <div className="flex-center justify-between w-100p mt-3">
            <h3 className="ml-1">{t("Jobs")}</h3>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
              gap={1}
            >
              <Input
                icon={<Search />}
                placeholder="Search Job"
                iconLeft
                name="search"
                value={text}
                onChange={(e) => {
                  if (!e.target.value) setSearch("");
                  setText(e.target.value);
                }}
                t={t}
                onKeyDown={(e) => e.key === "Enter" && setSearch(text)}
              />
              <GridSwitch setGridType={setGridType} gridType={gridType} />
            </Stack>
          </div>

          {!jobs?.length &&
          !loading &&
          parent === COMPONENT_TYPES.ORGANIZATION ? (
            disableManage || Boolean(search) ? (
              <EmptyText>{t("No Jobs Found!")}</EmptyText>
            ) : (
              <NuxLayout
                browseMode={0}
                newUserData={getJobNUX(navigateCreateJob)}
              />
            )
          ) : (
            <JobsListing
              jobs={jobs || []}
              loading={loading}
              gridType={gridType}
              setJobs={setJobs}
              manage={manage}
              smallView={smallView}
              page={page}
              setPage={setPage}
              pageCount={pages}
              emptyView={emptyView}
              deleteJob={handleDeleteJob}
              onApply={handleApplyJob}
              disableManage={disableManage}
            />
          )}
        </>
      )}
    </>
  );
};

export default AssociateJobsListing;
